import type { TrackingIntegration } from '@chukua/common';
import type { GpsIntegrationCounts } from '../hooks/use-gps-integration-counts';

export interface GpsRowFact {
  text: string;
  /** Needs someone's attention: devices with no truck, or polling that keeps failing. */
  isWarning?: boolean;
}

/** The line under a GPS integration's name on the Integrations page: its devices, then how its feed is doing. */
export function gpsRowFacts(integration: TrackingIntegration, counts: GpsIntegrationCounts | undefined): GpsRowFact[] {
  const facts: GpsRowFact[] = [];
  if (counts) {
    facts.push({ text: `${counts.mapped} ${counts.mapped === 1 ? 'device' : 'devices'} on trucks` });
    if (counts.unmapped > 0) facts.push({ text: `${counts.unmapped} reporting with no truck`, isWarning: true });
  }
  if (integration.consecutivePollFailures > 0) {
    facts.push({
      text: `Polling failed ${integration.consecutivePollFailures} ${integration.consecutivePollFailures === 1 ? 'time' : 'times'} in a row`,
      isWarning: true,
    });
  } else if (integration.lastPolledAt) {
    facts.push({ text: `Last polled ${new Date(integration.lastPolledAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}` });
  }
  return facts;
}
